export const formatDuration = (durationInMinutes) => {
  if (!durationInMinutes || isNaN(durationInMinutes)) return "0:00";

  // Convierte minutos a segundos
  const totalSeconds = Math.floor(durationInMinutes * 60);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  // Si hay horas, muestra hh:mm:ss
  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  }

  // Si no hay horas, muestra mm:ss
  return `${minutes}:${secs.toString().padStart(2, "0")}`;
};